import React from "react";
import BannerSectionStyle5 from "../Section/BannerSection/BannerSectionStyle5";
import { pageTitle } from "../../helpers/PageTitle";
import Header from  "../../components/Header";
import Footer from  "../../components/Footer";
import "../../sass/shortcode/TermsAndConditions.scss";
import { BASE_URL } from "../../helpers/api";

export default function TermsAndConditions() {
  pageTitle("Terms & Conditions");

  return (
    <>
      {/* Header Banner */}
      <BannerSectionStyle5
        bgUrl="/images/contact/banner_bg.svg"
        imgUrl="/images/Termscondition/pic1.png"
        title="Terms & Conditions"
        subTitle="Understand the Rules & Responsibilities"
      />

      {/* Terms & Conditions Content */}
      <div className="terms-container">
        <h2 className="terms-heading">Introduction</h2>
        <p>
           These Terms and Conditions (“Terms”) govern your use of our services,
          websites, and digital platforms. By accessing or using our services, you
          agree to comply with these Terms.
        </p>

        <h2 className="terms-heading">Use of Services</h2>
        <ul className="terms-list">
          <li>▪ You must use our services only for lawful purposes.</li>
          <li>▪ Unauthorized access, misuse, or distribution of our content is prohibited.</li>
          <li>▪ We reserve the right to modify, suspend, or terminate services at any time.</li>
        </ul>

        <h2 className="terms-heading">User Responsibilities</h2>
        <p> Users agree to:</p>
        <ul className="terms-list">
          <li>▪ Provide accurate and up-to-date information when required.</li>
          <li>▪ Maintain confidentiality of login credentials.</li>
          <li>▪ Avoid engaging in fraudulent or harmful activities.</li>
        </ul>

        <h2 className="terms-heading">Intellectual Property</h2>
        <p>
           All content, including text, graphics, logos, and software, is the
          property of <strong>Quality Care India Limited (QCIL)</strong> and is
          protected by applicable intellectual property laws.
        </p>

        <h2 className="terms-heading">Limitation of Liability</h2>
        <p>
           We are not liable for any direct, indirect, or consequential damages
          arising from the use of our services, except where required by applicable
          law.
        </p>

        <h2 className="terms-heading">Termination</h2>
        <p>
           We reserve the right to terminate or restrict your access if you breach
          these Terms or engage in unlawful activities.
        </p>

        <h2 className="terms-heading">Governing Law</h2>
        <p>
           These Terms shall be governed by and construed in accordance with the
          laws of India. Any disputes shall be subject to the exclusive jurisdiction
          of the courts in Hyderabad, Telangana.
        </p>

        <h2 className="terms-heading">Contact</h2>
        <p>
           For questions regarding these Terms, please contact us at{" "}
          <a href="mailto:legal@carehospitals.com" className="terms-link">
            legal@carehospitals.com
          </a>
          .
        </p>
      </div>
    </>
  );
}